class AdsImp {
  init() {}
}

export const Ads = new AdsImp();
